import { render, staticRenderFns } from "./CreateEditModal.vue?vue&type=template&id=351c167d"
import script from "./CreateEditModal.vue?vue&type=script&lang=js"
export * from "./CreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports